import { flexRender } from "@tanstack/react-table"

import { useTableContext } from "#Contexts/TableContext"
import Icon from "#React/ui/Icon/Icon"
import cn from "#Utils/cn"

const Headers = () => {
  const { table, header } = useTableContext()

  return (
    <thead className={cn("sticky z-20", { "top-14": header, "top-0": !header })}>
      <tr>
        {table.getFlatHeaders().map((header) => {
          const { minSize, maxSize, size } = header.column.columnDef
          const style = minSize || maxSize || size ? { width: header.getSize() } : {}
          return (
            <th key={header.id} colSpan={header.colSpan} className="c-table__th h-px" style={style}>
              {header.isPlaceholder ? null : (
                <div
                  {...{
                    className: `${header.column.getCanSort() ? "cursor-pointer select-none" : ""} ${
                      header.id === "selection" ? "text-center" : ""
                    }`,
                    onClick: header.column.getCanSort()
                      ? header.column.getToggleSortingHandler()
                      : undefined,
                  }}
                >
                  {flexRender(header.column.columnDef.header, header.getContext())}
                  {header.column.getCanSort() &&
                    ({
                      asc: (
                        <span className="ml-1">
                          <Icon name="far fa-angle-up" size="xs" />
                        </span>
                      ),
                      desc: (
                        <span className="ml-1">
                          <Icon name="far fa-angle-down" size="xs" />
                        </span>
                      ),
                    }[header.column.getIsSorted()] ??
                      null)}
                </div>
              )}
            </th>
          )
        })}
      </tr>
    </thead>
  )
}

export default Headers
